<template>
<div class="chapter">
<div class="inner_page">
<p class="colophon"><span>Europa Editions<br/>
 27 Union Square West, Suite 302<br/>
New York NY 10003<br/>
  info@europaeditions.com<br/>
  www.europaeditions.com<br/>
<br/>
  This book is a work of fiction. Any references to historical events, real people, or real locales are used fictitiously.<br/>
<br/>
  Copyright © 2019 by Kevin Chen<br/>
  All rights reserved.<br/>
Originally published in Taiwan by MirrorFiction Inc.<br/>
  First publication 2022 by Europa Editions<br/>
<br/>
  Translation by Darryl Sterk<br/>
  Original Title: <span class="ideogram">《鬼地方》<br/></span>Translation copyright © Darryl Sterk, 2020 <br/>
  English-language edition published in association with the Grayhawk Agency <br/>
  through Regal Hoffmann &amp; Associates LLC<br/>
All rights reserved.<br/>
<br/>
  All rights reserved, including the right of reproduction in whole or in part in any form.<br/>
<br/>
  Sponsored by the Ministry of Culture, Republic of China (Taiwan)<br/>
<br/>
  Art direction by Emanuele Ragnisco <br/>
  instagram.com/emanueleragnisco<br/>
<br/>
  Cover design and illustration by Ginevra Rapisardi<br/>
<br/>
  ISBN 9781609457990 <br/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Colophon.vue?11f4dbb7